// extracted by mini-css-extract-plugin
module.exports = {"container":"StatusBar_container__3bL5p","section":"StatusBar_section___eGUM","activeBar":"StatusBar_activeBar__2gNKY","statusBarContent":"StatusBar_statusBarContent__1EW5J"};